<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Popup header -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">
            View user
          </h4>
        </div>

        <!-- Popup content -->
        <div class="modal-body row" v-if="user">
          <!-- First name -->
          <div class="form-group col-xs-12 col-sm-6">
            <label>First Name</label>
            <div>{{ user.firstName }}</div>
          </div>

          <!-- Last name -->
          <div class="form-group col-xs-12 col-sm-6" >
            <label>Last name</label>
            <div>{{ user.lastName }}</div>
          </div>

          <!-- Email -->
          <div class="form-group col-xs-12 col-sm-6">
            <label>Email</label>
            <div>{{ user.email }}</div>
          </div>

          <!-- Role -->
          <div class="form-group col-xs-12 col-sm-6">
            <label>Role</label>
            <div>{{ userRoleLabel }}</div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'ViewUserModal',
  props: [ 'modalId', 'userData' ],
  data () {
    return {
      user: null
    }
  },
  watch: {
    userData: function (newuserData) {
      this.user = newuserData
    }
  },
  computed: {
    userRoleLabel () {
      return this.user.role === undefined ? '-' : config['userRolesDetails'][this.user.role]['display']
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ViewUserModal.vue?40ba02d1